import { Modal } from 'antd';
import React from 'react';
import DataTable from '@portal/components/DataTable/DataTable';
import { REPORT_PAGE_SIZE } from '@portal/config/env';
import { translate } from '@portal/services/i18n';
import { DateTime } from 'luxon';
import { moneyFormat } from '@portal/utils/format';

type InstallmentsModalProps = {
  isVisible: boolean;
  setIsVisible: (isVisible: boolean) => void;
  installments: models.LoanInstallment[];
};

const InstallmentsModal = ({
  isVisible,
  setIsVisible,
  installments,
}: InstallmentsModalProps) => {
  return (
    <div className="installments-modal">
      <Modal
        open={isVisible}
        footer={false}
        onCancel={() => setIsVisible(false)}
        width={1200}
      >
        <DataTable
          rows={installments ?? []}
          paginationMode="client"
          columns={[
            {
              field: 'id',
              flex: 1,
              headerName: 'id',
              sortable: false,
              hide: true,
            },
            {
              field: 'installment',
              headerName: translate(
                'PAGES.LOAN.SIMULATE.EXTERNAL_SIMULATION.INSTALLMENTS_MODAL.INSTALLMENT_NUMBER'
              ),
              flex: 1,
            },
            {
              field: 'amount',
              headerName: translate(
                'PAGES.LOAN.SIMULATE.EXTERNAL_SIMULATION.INSTALLMENTS_MODAL.AMOUNT'
              ),
              flex: 1,
              renderCell: (column) => (
                <div>
                  <div className="mr-2">{moneyFormat(column.row.amount)}</div>
                  <div className="mr-2">
                    {translate(
                      'PAGES.LOAN.SIMULATE.EXTERNAL_SIMULATION.INSTALLMENTS_MODAL.SELIC'
                    )}
                  </div>
                </div>
              ),
            },
            {
              field: 'mainAmount',
              headerName: translate(
                'PAGES.LOAN.SIMULATE.EXTERNAL_SIMULATION.INSTALLMENTS_MODAL.MAIN_AMOUNT'
              ),
              flex: 1,
              renderCell: (column) => moneyFormat(column.row.mainAmount),
            },
            {
              field: 'taxAmount',
              headerName: translate(
                'PAGES.LOAN.SIMULATE.EXTERNAL_SIMULATION.INSTALLMENTS_MODAL.TAX'
              ),
              flex: 1,
              renderCell: (column) => moneyFormat(column.row.taxAmount),
            },
            {
              field: 'dueDate',
              headerName: translate(
                'PAGES.LOAN.SIMULATE.EXTERNAL_SIMULATION.INSTALLMENTS_MODAL.DUE_DATE'
              ),
              flex: 1,
              renderCell: (column) =>
                DateTime.fromISO(column.row.dueDate).toLocaleString(
                  DateTime.DATE_SHORT
                ),
            },
          ]}
          pageSize={REPORT_PAGE_SIZE}
          orderBy="amount"
          sort="desc"
          getRowId={(row) => row.installment}
        />
      </Modal>
    </div>
  );
};

export default InstallmentsModal;
